export const categoriesArr = [
    {
      title: "Все",
      alt: "all"
    },
    {
      title: "Коти",
      alt: "cat"
    },
    {
      title: "Собаки",
      alt: "dog"
    },
    {
      title: "Птахи",
      alt: "bird"
    },
    {
      title: "Рибки",
      alt: "fish"
    },
    {
      title: "Гризуни",
      alt: "rodents"
    },
    {
      title: "Рептилії",
      alt: "reptiles"
    },
  ]
  